import * as yup from 'yup';

export const schema = yup.object({
  des_grupo: yup.string().trim().required(),
});
